// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (productId: string) => axios.get(`/products/${productId}/saves`);

export type LoadTempSavePayload = {
  productId: string,
  saveId: string,
};

export const loadTempSave = ({ productId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/products/${productId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/products/saves.js